import React, { useState, useEffect } from "react";
import SelectProvider from "./selectProvider";
// import useQuery from "../../shared/utils/queryParams";
import Loader from "../../shared/components/loader";
import ErrorMessage from "../../shared/components/errorMessage";
// import getMockProviderData from "./mockProviderData";

function SelectProviderContainer() {
  const [providers, setProviders] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessageText, setShowErrorMessageText] = useState(undefined);

  // const query = useQuery();

  const getProviders = async () => {
    try {
      // const response = getMockProviderData();
      const response = await fetch(process.env.REACT_APP_FAMILY_PROFILE_URL);
      const responseJson = await response.json();
      if (responseJson.metadata.outcome.status === 200) {
        setProviders(transformProviders(responseJson.data));
      } else {
        const errorMessage = getErrorMessage(
          responseJson.metadata.outcome.code
        );
        setShowErrorMessageText(errorMessage);
        setShowErrorMessage(true);
      }
    } catch (e) {
      setShowErrorMessageText(getErrorMessage(11));
      setShowErrorMessage(true);
    }
  };

  const transformProviders = (providers) => {};
  const getErrorMessage = (code) => {};

  useEffect(() => {
    getProviders();
  });

  // return showErrorMessage ? (
  //   <ErrorMessage title={"Error"} message={errorMessageText}></ErrorMessage>
  // ) : providers.length ? (
  //   <SelectProvider providers={providers}></SelectProvider>
  // ) : (
  //   <Loader></Loader>
  // );

  return <SelectProvider providers={providers}></SelectProvider>;
}

export default SelectProviderContainer;
